// material
import ModernTable from '../../components/ModernTable';
import { TableInfoTitle } from './InfoTip';
import { MARKETING_INFO } from './marketingInfo';
import { useTheme } from '@mui/material/styles';
import { Box, Typography, Chip, alpha } from '@mui/material';
import CategoryIcon from '@mui/icons-material/Category';
import AddShoppingCartIcon from '@mui/icons-material/AddShoppingCart';
import DescriptionIcon from '@mui/icons-material/Description';
import InfoIcon from '@mui/icons-material/Info';
import ChecklistIcon from '@mui/icons-material/Checklist';
import TrendingUpIcon from '@mui/icons-material/TrendingUp';

export default function ProdTable(props) {
  const theme = useTheme();
  const { data } = props;

  // const MyNewTitle = ({ text = 'Table Title', variant = 'h6' }) => (
  //   <Typography variant={variant} style={{ overflow: 'hidden', textOverflow: 'ellipsis' }}>
  //     {`Product Table (${machinesName} from ${startDate.toShortFormat()} to  ${endDate.toShortFormat()})`}
  //   </Typography>
  // );

  const columns = [
    {
      title: 'Name',
      field: 'name',
      render: (rowData) => (
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <CategoryIcon sx={{ fontSize: 16, color: theme.palette.text.secondary }} />
          <Typography variant="body2" sx={{ fontWeight: 600 }}>
            {rowData.name}
          </Typography>
        </Box>
      ),
    },
    {
      title: 'Added To Cart',
      field: 'add_to_cart',
      render: (rowData) => (
        <Chip
          icon={<AddShoppingCartIcon sx={{ fontSize: 16 }} />}
          label={rowData.add_to_cart}
          size="small"
          sx={{
            fontWeight: 600,
            backgroundColor: alpha(theme.palette.success.main, 0.12),
            color: theme.palette.success.dark,
            border: `1.5px solid ${alpha(theme.palette.success.main, 0.3)}`,
            '& .MuiChip-icon': {
              color: theme.palette.success.dark,
            },
          }}
        />
      ),
    },
    {
      title: 'Detail Page',
      field: 'detail',
      render: (rowData) => (
        <Chip
          icon={<DescriptionIcon sx={{ fontSize: 16 }} />}
          label={rowData.detail}
          size="small"
          sx={{
            fontWeight: 600,
            backgroundColor: alpha(theme.palette.info.main, 0.12),
            color: theme.palette.info.dark,
            border: `1.5px solid ${alpha(theme.palette.info.main, 0.3)}`,
            '& .MuiChip-icon': {
              color: theme.palette.info.dark,
            },
          }}
        />
      ),
    },
    {
      title: 'Specification',
      field: 'specs',
      render: (rowData) => (
        <Chip
          icon={<InfoIcon sx={{ fontSize: 16 }} />}
          label={rowData.specs}
          size="small"
          sx={{
            fontWeight: 600,
            backgroundColor: alpha(theme.palette.primary.main, 0.12),
            color: theme.palette.primary.dark,
            border: `1.5px solid ${alpha(theme.palette.primary.main, 0.3)}`,
            '& .MuiChip-icon': {
              color: theme.palette.primary.dark,
            },
          }}
        />
      ),
    },
    {
      title: 'What included',
      field: 'includes',
      render: (rowData) => (
        <Chip
          icon={<ChecklistIcon sx={{ fontSize: 16 }} />}
          label={rowData.includes}
          size="small"
          sx={{
            fontWeight: 600,
            backgroundColor: alpha(theme.palette.secondary.main, 0.12),
            color: theme.palette.secondary.dark,
            border: `1.5px solid ${alpha(theme.palette.secondary.main, 0.3)}`,
            '& .MuiChip-icon': {
              color: theme.palette.secondary.dark,
            },
          }}
        />
      ),
    },
    {
      title: 'Conversion',
      field: 'conv',
      render: (rowData) => (
        <Chip
          icon={<TrendingUpIcon sx={{ fontSize: 16 }} />}
          label={rowData.conv}
          size="small"
          sx={{
            fontWeight: 600,
            backgroundColor: alpha(theme.palette.warning.main, 0.12),
            color: theme.palette.warning.dark,
            border: `1.5px solid ${alpha(theme.palette.warning.main, 0.3)}`,
            '& .MuiChip-icon': {
              color: theme.palette.warning.dark,
            },
          }}
        />
      ),
    },
  ];

  return (
    <ModernTable
      title={<TableInfoTitle title={'Products'} info={MARKETING_INFO.products} />}
      columns={columns}
      data={data}
      options={{
        actionsColumnIndex: -1,
        pageSize: 5,
      }}
    />
  );
}
